import { AfterSalesStatusEnum } from 'enums/AfterSalesStatus'

import { Tag } from '@interco/inter-ui/components/Tag'

import * as S from './AfterSalesStatusTag.styles'

interface IStatusTag {
  status: string
  color: string
  colorText?: string
}

interface IProps {
  status: AfterSalesStatusEnum
}

export const AfterSalesStatusTag = ({ status }: IProps) => {
  type AfterSalesStatusEnumKeys = {
    [key in AfterSalesStatusEnum]: IStatusTag
  }

  const statusTags: AfterSalesStatusEnumKeys = {
    [AfterSalesStatusEnum.ACTIVE]: {
      status: 'Ativo',
      color: 'var(--success500)',
    },
    [AfterSalesStatusEnum.PARTNER_IN_PROCESS]: {
      status: 'Em análise',
      color: 'var(--alert100)',
      colorText: 'var(--gray500)',
    },
    [AfterSalesStatusEnum.SUSPENDED]: {
      status: 'Suspenso',
      color: 'var(--gray100)',
      colorText: 'var(--gray500)',
    },
    [AfterSalesStatusEnum.CANCELED]: {
      status: 'Cancelado',
      color: 'var(--error500)',
    },
  }

  return statusTags[status] ? (
    <S.StatusTag>
      <Tag colorText={statusTags[status].colorText} color={statusTags[status].color}>
        {statusTags[status].status}
      </Tag>
    </S.StatusTag>
  ) : (
    <></>
  )
}
